import { useEffect, useState, useCallback,useMemo } from 'react';
import Pagination from '@src/common/Pagination';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_PAGE_NO, DEFAULT_PAGINATION_COUNT, LEAD_LIST_HEADER_COLUMN, COUNTRY_CODE, LEAD_LIST_HEADER_COLUMN_ID } from '@src/config/constant';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { getMasterConfig } from '@src/store/slices/insurance';
import ShowQuotationID from './ShowQuotationID'
import secureStorage from '@src/config/encrypt';
import { IS_PAYMENT, LEAD_STATUS, LEAD_STATUS_ID, ROLE } from '@src/config/id/constant';
import LeadHistoryModal from '@src/pages/LeadHistoryModal';
import HistoryModel from './HistoryModel';
import { setInsuranceDetail } from '@store/slices/insuranceId';
import { GENERATE_URL } from '@src/config/id/constant';
import { useLanguage } from "@src/context/LanguageContext";
import { isMobile } from "react-device-detect";

function InsuranceListTableID(props: any) {
    let {
        insuranceList,
        paginationData,
        selectedFilters,
        current_nav,
        setShowPaymentInfoPopup,
        setLeadDetails,
        setShowPaymentDetailsPopup,
        setShowAgentPointPopup,
        setLoading,
        activeTab, setShowPointsApprovalPopup, setSummaryPopup, setOpenMenuId, openMenuId, insuranceListData, setInsuranceListData
    } = props;

    const navigate = useNavigate();
    const page = DEFAULT_PAGE_NO;
    const commonState = useSelector((state: any) => state.common)
    const [masterConfig, setMasterConfig] = useState<any>({});
    const [screenType, setScreenType] = useState('');
    const [showQuoteInfoPopup, setShowQuoteInfoPopup] = useState(false);
    const [selectedLead, setSelectedLead] = useState<any>(null);
    const [showHistoryModel, setShowHistoryModel] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);

    let auth = secureStorage.getItem("authAgentUserInfo");
    const roleId = auth?.user_data?.role_id;
    const isCountryId = COUNTRY_CODE === 'id' ? true : false;

    // Agent Name column: shown only to BM accounts on the Quotation Shared / On Process / Issued tabs,
    // placed right after the Insurance ID column. Agents (and other roles) keep the existing layout.
    const AGENT_NAME_TABS = ["quotation_shared", "submitted", "policy_issued"];
    const INSURANCE_ID_COL_INDEX = 3;
    const showAgentNameCol = roleId === ROLE.BM && AGENT_NAME_TABS.includes(selectedFilters?.status_type);

    const dispatch: any = useDispatch();
    const { translations } = useLanguage();

    useEffect(() => {
        setInsuranceListData(insuranceList);
    }, [insuranceList]);

    const fetchMasterConfig: any = useCallback(async () => {
        try {
            const res: any = await dispatch(getMasterConfig());
            if (res) {
                setMasterConfig(res);
            }
        } catch (error) {
            console.error("Failed to fetch master config:", error);
        }
    }, [dispatch]);

    useEffect(() => {
        if (!commonState?.common || Object.keys(commonState.common).length === 0) {
            fetchMasterConfig();
        } else {
            setMasterConfig(commonState.common);
        }
    }, [commonState?.common, fetchMasterConfig]);


    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            page_number: params.page_no,
            shared_on_sort:sharedOnSort
        }

        props.getInsuranceListing(apiParams)

    }

    const goToQuoteDetail = (leadId: any) => {
        navigate(`/quote-details/${leadId}`);
    }

    const showPaymentInfo = (leadData: any, screenType = "pending_payment") => {
        setShowPaymentInfoPopup(true);
        setLeadDetails(leadData);
    }


    // show Quation modal
    const showQuotationtInfo = (lead: any, screenType = translations?.TASK_SUMMARY?.SHARED_QUOTATION_PREVIEW) => {
        setSelectedLead(lead);
        setScreenType(screenType);
        setShowQuoteInfoPopup(true);

    }

    // 
    const downloadFile = (files: any[]) => {
        files.flat().forEach((file, index) => {
            if (!file.doc_path) return;

            setTimeout(() => {
                const link = document.createElement("a");
                link.href = file.doc_path;
                link.download = file.name || `file_${index}`;
                link.target = "_blank";

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }, index * 300);
        });
    };

    // order of the last listing call (InsuranceList defaults to DESC = newest first); pagination and
    // the header arrow always follow it, so page 2+ keeps the same order as page 1
    const lastListFilters = useSelector((state: any) => state.insurance?.insuranceListFilters);
    const sharedOnSort: "ASC" | "DESC" =
        String(lastListFilters?.shared_on_sort || "DESC").toUpperCase() === "ASC" ? "ASC" : "DESC";

    // toggle order and reload from page 1 with the NEW order
    const handleSharedOnSort = () => {
        const nextSort = sharedOnSort === "ASC" ? "DESC" : "ASC";
        props.getInsuranceListing({ ...selectedFilters, page_number: 1, shared_on_sort: nextSort });
    };

    const viewDetails = (lead_id: number) => {
        secureStorage.setItem('lead_id', lead_id);
        navigate(`/create-insurance-policy`);
    };

    // Continue Application: reopen a Quotation Shared lead's Create Application form, pre-filled.
    // Continue is only for leads still at Quotation Shared (1/1), i.e. not yet submitted to IB.
    // Once docs are submitted the lead moves to Application Created and shows in IB.
    const canContinueApplication = (lead: any) =>
        +lead?.status === LEAD_STATUS.quotation_shared.status_id &&
        +lead?.sub_status === LEAD_STATUS.quotation_shared.sub_status_id;

    // Resume at the lead's current step: Docs by default; the create page switches to Quote when the
    // quotation was shared with multiple insurers and no final quote/docs data exists yet.
    // (agent can still go back to Application / Add-ons / Quote from the left panel).
    const continueApplication = (lead: any) => {
        secureStorage.setItem('lead_id', lead.leadId);
        secureStorage.removeItem('goToQuote');
        secureStorage.setItem('goToDocs', 'true');
        navigate('/create-insurance-policy?step=documents');
    };


    // show Quation modal
    const showAgentDetailsModal = (lead: any) => {
        setSelectedLead(lead);
        // setScreenType(screenType);
        setShowAgentPointPopup(true);

    }

    const handleMenuClick = (type: string, lead: any) => {
        setOpenMenuId(null);

        if (type === "edit_details") {
            viewDetails(lead.leadId);
        }

        // Edit profit modal
        if (type === "edit_profit") {
            //navigate(`/edit-agent-profit/${lead.leadId}`);
            setLeadDetails(lead);
            setShowAgentPointPopup(true);
        }

        if (type === "view_history") {
            setSelectedLead(lead.leadId);
            setShowHistoryModal(true);
            setOpenMenuId(null);

        }

        if (type === "make_payment") {
            showPaymentInfo(lead)
        }
    };

    const handlePaymentButton = async (lead: Record<string, any>) => {
        await dispatch(setInsuranceDetail(lead))
        const { action } = getPaymentAction(lead);
        if (action === 'GENERATE') {
            if(isMobile){
                navigate(`/generate-payment-link-app/${lead.leadId}`, {
                    state: { showAdditionalDiscount: true }
                });
            }else{
                navigate(`/generate-payment-link/${lead.leadId}`, {
                    state: { showAdditionalDiscount: true }
                });
            }
        } else {
            setShowPaymentDetailsPopup(true);
            setLeadDetails(lead);
        }

    };
    const getPaymentAction = (lead: any) => {
        const hasTransaction =
            Object.keys(lead?.transaction_detail ?? {}).length > 0;

        if (lead?.is_generate_url === GENERATE_URL.TRUE && hasTransaction) {
            return {
                label: 'View Payment Details',
                action: 'VIEW'
            };
        } else if (
            lead?.is_generate_url === GENERATE_URL.FALSE &&
            hasTransaction &&
            lead?.transaction_detail?.payment_status_slug === 'paid'
        ) {
            return {
                label: 'View Payment Details',
                action: 'VIEW'
            };
        }

        return {
            label: 'Generate Payment Link',
            action: 'GENERATE'
        };
    };


    const handleApprovalClick = async (lead: any) => {
        //setLoading(true);
        try {
            if (auth.user_data.role_id === ROLE.VP) {
                setShowPointsApprovalPopup(true);   // VP 
            } else if ([ROLE.BM, ROLE.AM].includes(auth.user_data.role_id)) {
                setSummaryPopup(true);      // BM / AM
            }
            setLeadDetails(lead);
            // setShowAgentPointPopups(true);
        } catch (e) {
            console.error(e);
        }
        //setLoading(false);
    };

    // const HEADER_COLUMN = isCountryId ? translations?.TASK_SUMMARY?.TAB : LEAD_LIST_HEADER_COLUMN;
    const HEADER_COLUMN = useMemo(() => {
        if (!isCountryId) return LEAD_LIST_HEADER_COLUMN;
        return translations?.TASK_SUMMARY?.TAB || [];
    }, [isCountryId, translations]);

    const tableColumns: string[] = useMemo(() => {
        const columns = HEADER_COLUMN[selectedFilters?.status_type || selectedFilters?.type] || [];
        if (!showAgentNameCol) return columns;
        const withAgent = [...columns];
        withAgent.splice(INSURANCE_ID_COL_INDEX + 1, 0, translations?.TASK_SUMMARY?.AGENT_NAME_COLUMN || "Agent Name");
        return withAgent;
    }, [HEADER_COLUMN, selectedFilters?.status_type, selectedFilters?.type, showAgentNameCol, translations]);

    const goToQuote = secureStorage.getItem('goToQuote');
    if (goToQuote) {
        navigate('/create-insurance-policy?step=quote');
        secureStorage.removeItem('goToQuote');
    }
    
     
    return (
        <>
            <div className={(selectedFilters?.type && selectedFilters?.type === "claim") ? `lead-list-data-table data-table managepanel-tab claim-list-type wap-table` : `lead-list-data-table data-table managepanel-tab wap-table`} >
                <table className={`tasklist-table-id ${props.activeTab === "policy_issued" && auth.user_data.role_id !== ROLE.VP  ? "issue-table-id": "vp-issue-tbl"} ${props.activeTab === "policy_issued" && [ROLE.AGENT, ROLE.BM]?.includes(auth.user_data.role_id) ? "agent-issue-table issued-agnet-table-main" : ""} ${showAgentNameCol ? "with-agent-name-col" : ""}`}>
                   
                    <thead>
                        <tr>
                            {
                                tableColumns?.map((data: any, index: number) =>
                                    <th key={index}>
                                        {data === "Shared on" ? (
                                            <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }} onClick={handleSharedOnSort} >
                                                {data}
                                                <span className="sort-arrow">
                                            {sharedOnSort === "ASC" ? "▲" : "▼"}
                                        </span>
                                            </span>
                                        ) : (
                                            data
                                        )}
                                    </th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            insuranceListData?.length ?
                                insuranceListData?.map((lead: any, key: number) =>
                                {
                                    const showApproval = [ROLE.VP, ROLE.BM, ROLE.AM].includes(auth.user_data.role_id) && (lead?.agent_point_send && activeTab === "submitted");
                                    const backgroundColor = lead.status === LEAD_STATUS_ID.LOST ? "#E92F2F" : "";
                                        
                                    return(
                                    <tr key={key} className={!isMobile && showApproval ? "Approval-point" : ""}>
                                        {isMobile &&
                                            ["quotation_shared", "submitted","policy_issued"].includes(selectedFilters?.status_type) && (
                                                <td>
                                                    <div className="table-txt-data status-btn-id">
                                                        <span title="status_name" className="status-submitted-badge" style={{backgroundColor}}>
                                                            {lead.status_name || ""}
                                                        </span>
                                                   {           
                                                (!current_nav && ["policy_issued"].includes(selectedFilters?.status_type)) && (
                                                <>
                                                    {
                                                        Object.keys(lead?.transaction_detail ?? {}).length > 0 &&
                                                        
                                                            
                                                                <span className='payment-status m-sm-l' style={{ backgroundColor: lead?.transaction_detail?.color_code }}> {lead?.transaction_detail?.payment_status}</span>
                                                            
                                                        
                                                    }

                                                    {
                                                        Object.keys(lead?.transaction_detail ?? {}).length === 0 &&
                                                        
                                                           
                                                                <span className='payment-status m-sm-l' style={{ backgroundColor: "#F88736" }}>{translations?.GENERATE_PAYMENT?.PENDING}</span>
                                                            
                                                        
                                                    }
                                                </>

                                            )
                                        }
                                        
                                                        
                                                    </div>
                                                      
                                                </td>
                                            )
                                        }


                                

                                        <td >
                                            <div className="table-txt-data">
                                                <h5 title={`${lead.name}`}>{lead.name || lead?.customer_name ||""}</h5>
                                            </div>
                                             {!isMobile && showApproval &&
                                           
                                                <div
                                                    className="approval-bar"
                                                    onClick={() => handleApprovalClick(lead)}
                                                >
                                                    <span>
                                                        {translations?.AGENT_COMMISSION?.APPROVAL_AGENT_POINT}{" "}
                                                        <span className="percent">
                                                            {lead.new_agent_points?.percentage}%
                                                        </span>
                                                    </span>

                                                    <span className="view-btn">{translations?.AGENT_COMMISSION?.VIEW}</span>
                                                </div>

                                        
                                        }
                                    
                                        </td>
                                        
                           

                                        <td>
                                            <div className="table-txt-data">
                                                <h5 title={`${lead.make_name || ""} ${lead.model_name || ""} ${lead.version_name || ""} ${lead.plate_number || ""}`}>{`${lead.make_name || ""} ${lead.model_name || ""} ${lead.version_name || ""} ${lead.plate_number || ""}`}</h5>
                                            </div>
                                        </td>

                                        <td >
                                            <div className="table-txt-data">
                                                <span title="Insurer">{lead.insurer_name || ""}</span>
                                            </div>
                                        </td>

                                        <td>
                                            <div className="table-txt-data">
                                                <span title="lead_code">{lead.lead_code || ""}</span>
                                            </div>
                                        </td>

                                        {showAgentNameCol &&
                                            <td>
                                                <div className="table-txt-data">
                                                    <span title={lead.agent_name || ""}>{lead.agent_name || "-"}</span>
                                                </div>
                                            </td>
                                        }


                                        <td >
                                            <div className="table-txt-data">
                                                <span title="created_date"> {lead.created_on ? new Date(lead.created_on).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : ""}</span>
                                            </div>
                                        </td>



                                        {!isMobile &&
                                            ["quotation_shared", "submitted","policy_issued"].includes(selectedFilters?.status_type) && (
                                                <td>
                                                    <div className="table-txt-data status-btn-id">
                                                        <span title="status_name" className="status-submitted-badge" style={{backgroundColor}}>
                                                            {lead.status_name || ""}
                                                        </span>
                                                    </div>
                                                </td>
                                            )
                                        }
                                        {!isMobile &&
                                            (!current_nav && ["policy_issued"].includes(selectedFilters?.status_type)) && (
                                                <>
                                                    {
                                                        Object.keys(lead?.transaction_detail ?? {}).length > 0 &&
                                                        <td >
                                                            <div className="table-txt-data">
                                                                <span className='payment-status' style={{ backgroundColor: lead?.transaction_detail?.color_code }}> {lead?.transaction_detail?.payment_status}</span>
                                                            </div>
                                                        </td>
                                                    }

                                                    {
                                                        Object.keys(lead?.transaction_detail ?? {}).length === 0 &&
                                                        <td >
                                                            <div className="table-txt-data">
                                                                <span className='payment-status' style={{ backgroundColor: "#F88736" }}>{translations?.GENERATE_PAYMENT?.PENDING}</span>
                                                            </div>
                                                        </td>
                                                    }
                                                </>
                                            )
                                        }
                                        {isMobile &&
                                        <td className='agnet-approve-msg'>
                                               { showApproval &&
                                           
                                                <div
                                                    className="approval-bar"
                                                    
                                                >
                                                    <span>
                                                        {translations?.AGENT_COMMISSION?.APPROVAL_AGENT_POINT}{" "}
                                                        <span className="percent">
                                                            {lead.new_agent_points?.percentage}%
                                                        </span>
                                                    </span>

                                                    <span className="view-btn" onClick={() => handleApprovalClick(lead)}>{translations?.AGENT_COMMISSION?.VIEW}</span>
                                                </div>

                                        
                                        }
                                    
                                        </td>
                                }


                                        <td className= {isMobile ? "raised-claimed-btn-list" : ""}>
                                            <div className={isMobile ? "table-txt-data d-flex raise-payment-btn" : "table-txt-data d-flex"}>
                                                {(current_nav || ["quotation_shared", "submitted"].includes(selectedFilters?.status_type)) &&


                                                    <>
                                                        <button className="btn-line btn-width-auto m-sm-r" onClick={() => showQuotationtInfo(lead)}>
                                                          
                                                           <i className={isMobile ? "ic-application m-xs-r" : "m-xs-"}></i> {translations?.TASK_SUMMARY?.SHOW_QUOTATION} </button>
                                                        {selectedFilters?.status_type === "quotation_shared" && [ROLE.AGENT, ROLE.BM, ROLE.AM].includes(roleId) && canContinueApplication(lead) &&
                                                            <button className="btn-line btn-width-auto m-sm-r" onClick={() => continueApplication(lead)}>
                                                               <i className={isMobile ? "ic-arrow_forward m-xs-r" : "m-xs-"}></i> {translations?.TASK_SUMMARY?.CONTINUE_APPLICATION} </button>
                                                        }
                                                        {/* {
                                            lead?.is_payment &&
                                            <button className="btn-line btn-width-auto m-sm-r" onClick={() => showPaymentInfo(lead)}>
                                                <i className="m-xs-r"></i>{translations?.TASK_SUMMARY?.MAKE_PAYMENT}</button>

                                        } */}
                                                    </>
                                                }
                                                {
                                                    (!current_nav && ["policy_issued"].includes(selectedFilters?.status_type)) && (
                                                       <div className={isMobile ? "d-flex btn-mobile-id" : "action-btn-issued d-flex btn-mobile-id"}>
                                                              {!([ROLE.VP, ROLE.SH].includes(roleId))  &&  
                                                            <button
                                                                className="btn-line btn-width-auto m-sm-r btn-genearte"
                                                                onClick={() => handlePaymentButton(lead)}
                                                                disabled={lead?.is_generate_url === GENERATE_URL.FALSE && lead?.transaction_detail?.payment_status_slug !== 'paid'}
                                                            >
                                                                <i className={isMobile ? "ic-attach_file m-xs-r" : ""}></i>
                                                                {
                                                                    getPaymentAction(lead).label
                                                                }

                                                            </button>
                                                            }

                                                            {lead?.policy_documents?.length>0 &&
                                                                <button className="btn-line btn-width-auto m-sm-r" onClick={() => downloadFile(lead?.policy_documents)}>
                                                                     <i className={isMobile ? "ic-save_alt m-xs-r" : ""}></i> {translations?.TASK_SUMMARY?.DOWNLOAD_POLICY}</button>
                                                            }
                                                        </div>

                                                    )

                                                }

                                                {/* <button onClick={() => showAgentDetailsModal(lead)}>⋮</button> */}                                         

                                            
                                            {props?.activeTab !== 'quotation_shared' &&
                                                    <div className="kebab-wrapper">

                                                    {
                                                        props?.activeTab =='policy_issued' && lead.is_payment===IS_PAYMENT.ALLOWED &&  (
                                                            
                                                            <button
                                                                className="kebab-btn"
                                                                onClick={() =>
                                                                    setOpenMenuId(openMenuId === lead.leadId ? null : lead.leadId)
                                                                }
                                                            >
                                                                ⋮
                                                            </button>
                                                        )
                                                    }

                                                    {
                                                        props?.activeTab =='submitted' &&  (
                                                            
                                                            <button
                                                                className="kebab-btn"
                                                                onClick={() =>
                                                                    setOpenMenuId(openMenuId === lead.leadId ? null : lead.leadId)
                                                                }
                                                            >
                                                                ⋮
                                                            </button>
                                                        )
                                                    }

                                                        {openMenuId === lead.leadId && (

                                                            <div className="kebab-menu">
                                                                {((roleId === ROLE.AGENT || roleId === ROLE.BM || roleId === ROLE.AM) && lead.status < 2 && lead.sub_status < 3) && activeTab === "submitted" &&
                                                                    <div onClick={() => handleMenuClick("edit_details", lead)}>
                                                                        {translations?.TASK_SUMMARY?.EDIT_DETAILS}
                                                                    </div>
                                                                }
                                                                {((roleId === ROLE.BM || roleId === ROLE.AM)&& (lead.agent_point_Approved === false || lead.agent_point_send === true) && lead.status < 5 && lead.sub_status < 8) && activeTab === "submitted" &&
                                                                    <div onClick={() => handleMenuClick("edit_profit", lead)}>
                                                                        {translations?.TASK_SUMMARY?.EDIT_AGENT_PROFIT}
                                                                    </div>
                                                                }

                                                                {([ROLE.AGENT, ROLE.BM, ROLE.VP, ROLE.SH, ROLE.AM].includes(roleId)) && activeTab === "submitted" &&

                                                                    <div onClick={() => handleMenuClick("view_history", lead)}>
                                                                        {translations?.TASK_SUMMARY?.VIEW_HISTORY}
                                                                    </div>
                                                                }

                                                                {([ROLE.AGENT, ROLE.BM, ROLE.VP, ROLE.SH].includes(roleId)) && activeTab === "policy_issued" &&

                                                                    <div onClick={() => handleMenuClick("make_payment", lead)}>
                                                                        {translations?.TASK_SUMMARY?.MAKE_PAYMENT}
                                                                    </div>
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                           
                                    </tr>
                                )
                                }
                                )
                                :
                                (paginationData && Object.keys(paginationData).length > 0 && (
                                    <tr><td colSpan={tableColumns?.length} style={{ textAlign: 'center' }}>No data found</td></tr>
                                ))
                        }
                    </tbody>
                </table>

                {
                    showQuoteInfoPopup && <ShowQuotationID show={showQuoteInfoPopup} handleClose={() => { setShowQuoteInfoPopup(false) }} leadDetail={selectedLead} screenType={screenType} setLoading={setLoading} />
                }
                {
                    showHistoryModel && <HistoryModel show={showHistoryModel} handleClose={() => { setShowHistoryModel(false) }} leadDetail={selectedLead} />
                }

                {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination paginateData={{
                    page,
                    loading: false,
                    totalLengthWithoutPagination: paginationData['total'],
                    paginationData,
                    filteredData: selectedFilters
                }}
                    sendRequestDataToParent={handleRequestData} />}

            </div >
            {
                isCountryId &&
                <LeadHistoryModal
                    viewTimeLine={showHistoryModal}
                    selectedLeadId={selectedLead}
                    handleViewTimeLine={(flag: boolean) => {
                        setShowHistoryModal(flag);
                        if (!flag) setSelectedLead(null);
                    }}
                />
            }

        </>
    )
}

export default InsuranceListTableID
